import { useMutation } from '@tanstack/react-query';

import { CreateUpdateLocationRequest, getSMPBackendAPIAdmin } from '@/proxy';

type UpdateLocationParams = {
  id: string;
  data: CreateUpdateLocationRequest;
};

function updateLocation({ id, data }: UpdateLocationParams) {
  return getSMPBackendAPIAdmin().locationsControllerUpdateV1(id, data);
}

export function useUpdateLocation() {
  return useMutation({ mutationFn: updateLocation });
}
